import { useEffect, useState } from "react";
import { Copy, Check, Layers } from "lucide-react";
import { toast } from "sonner";
import { fetchGroups, fetchRooms } from "@/lib/chatApi";

const snippet = (origin, id) => `<iframe src="${origin}/widget?group=${id}"
  style="position:fixed;bottom:0;right:0;border:0;
  width:440px;height:660px;z-index:99999"
  allowtransparency="true"></iframe>`;

function GroupSnippet({ group, roomNames, origin }) {
  const [copied, setCopied] = useState(false);
  const code = snippet(origin, group.id);
  const copy = async () => {
    try {
      try {
        await navigator.clipboard.writeText(code);
      } catch {
        const ta = document.createElement("textarea");
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand("copy");
        ta.remove();
        if (!ok) throw new Error("copy failed");
      }
      setCopied(true);
      toast.success(`Snippet "${group.name}" disalin`);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Gagal menyalin, salin manual");
    }
  };
  return (
    <div data-testid={`embed-group-${group.id}`} className="text-left bg-slate-900/70 border border-slate-800 rounded-2xl p-4">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div>
          <p className="text-white font-semibold text-sm flex items-center gap-2" data-testid={`embed-group-name-${group.id}`}>
            <Layers className="w-4 h-4 text-indigo-300" /> {group.name}
          </p>
          <div className="flex flex-wrap gap-1.5 mt-2" data-testid={`embed-group-rooms-${group.id}`}>
            {roomNames.length ? roomNames.map((n) => (
              <span key={n} className="px-2 py-0.5 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-200 text-[11px]">#{n}</span>
            )) : <span className="text-slate-500 text-xs">Belum ada room</span>}
          </div>
        </div>
        <button
          data-testid={`embed-group-copy-${group.id}`}
          onClick={copy}
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white text-xs font-semibold transition-colors"
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? "Disalin" : "Salin"}
        </button>
      </div>
      <pre data-testid={`embed-group-code-${group.id}`} className="text-xs bg-slate-950 border border-slate-800 rounded-xl p-3 text-emerald-300 overflow-x-auto">{code}</pre>
    </div>
  );
}

export function GroupEmbedList({ origin }) {
  const [groups, setGroups] = useState(null);
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    Promise.all([fetchGroups(), fetchRooms()])
      .then(([g, r]) => { setGroups(g); setRooms(r); })
      .catch(() => setGroups([]));
  }, []);

  const nameOf = (id) => rooms.find((r) => r.id === id)?.name;

  return (
    <div className="max-w-xl mx-auto mt-8" data-testid="embed-group-list">
      <p className="text-slate-300 mb-2 text-sm font-semibold text-left">
        3. Per group — pakai <code className="text-indigo-300">?group=&lt;id&gt;</code>, widget hanya menampilkan room di group tersebut
      </p>
      {groups === null ? (
        <p className="text-slate-500 text-xs text-left">Memuat group...</p>
      ) : groups.length === 0 ? (
        <p className="text-slate-500 text-xs text-left" data-testid="embed-group-empty">Belum ada group. Admin dapat membuat group dari aplikasi utama.</p>
      ) : (
        <div className="space-y-3">
          {groups.map((g) => (
            <GroupSnippet key={g.id} group={g} origin={origin} roomNames={(g.room_ids || []).map(nameOf).filter(Boolean)} />
          ))}
        </div>
      )}
    </div>
  );
}
